import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../../core';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class LicensesActivityReportService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/crawler/licenses');
  }

  getReportData(options?: Object): Promise<any> {
    const url = `${this.baseUrl}/report`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions(options)))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }

  downloadData(options?: Object) {
    const url = `${this.baseUrl}/csv`;
    const optionsData = this.getRequestOptions(options);
    Object.assign(optionsData, { responseType: 'text' });
    this.http.get(url, optionsData).subscribe({
      next: (success) => {
        const blob = new Blob([success], { type: 'text/csv' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'data.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      error: (error) => this.handleObservableError(error)
    });
  }
}
